export default {
  'initial.dataset.dragNode': function () {
    return {
      'node.appearing': () => {
        return [{
          initialAttr: {
            opacity: 0
          },
          finalAttr: {
            opacity: 1
          },
          slot: 'axis'
        }];
      }
    };
  }
};
